import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Se encacarga de listar tabla direcciones clientes
//CustomerId: id del cliente a consultar
//UserId: id usuario logueado
export const ObtenerTablaRegistros = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/CustomerAddress/Listado/', registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// metodo para crear nuevo registro, recibe:
//const objetoRegistro = {
//    CustomerId: id cliente seleccionado
//    Ubication4Id: id ubicación 4, requerido
//    AddressTypeId: id tipo direccion seleccionada
//    CuaPostalCode: codigo postal maximo 20 caracteres
//    CuaAddress: direccion max 200 caracteres
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const CrearNuevoRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerAddress/Guardar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Se encacarga de la actualizacion de un registro, recibe:
//const objetoRegistro = {
//    CustomerAddressId: id del registro a actualizar (registro cliente/direccion),
//    CustomerId: id cliente seleccionado
//    Ubication4Id: id ubicación 4, requerido
//    AddressTypeId: id tipo direccion seleccionada
//    CuaPostalCode: codigo postal maximo 20 caracteres
//    CuaAddress: direccion max 200 caracteres
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const ActualizarRegistro = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerAddress/Actualizar/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para eliminar un registro, recibe:
//const data = {
//    CustomerAddressId: id del registro a eliminar (registro cliente/direccion),
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const EliminarRegistro = (data) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerAddress/Eliminar/", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se usa para esatblecer un registro favorito, recibe:
//const data = {
//    CustomerAddressId: id del registro a eliminar (registro cliente/direccion),
//    CustomerId: id cliente seleccionado
//    CompanyId: id compañía usuario logueado
//    UserId: id usuario logueado
//};
export const EstablecerFavorito = (data) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/CustomerAddress/Favorito/", data).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};
